export const messages = {
    en: {
        lang: {
            en: 'English',
            de: 'German',
        },
        global: {
            serviceHolder: 'Services',
            cancel: 'Cancel',
            close: 'Close',
            add: 'Add',
            delete: 'Delete',
            edit: 'Edit',
            ok: 'ОК',
            save: 'Save',
            toDay: 'Today',
            messageEmpty: 'No messages',
            image: 'Image',
            show: 'Show',
            hide: 'Hide',
            areUsure: 'Are you sure?',
        },
        call: {
            screenShot: 'Make a screenshot',
            connect: 'Outcoming connection with',
        },
        status: {
            new: 'In review',
            approved: 'Technicians assigned and preliminary cost calculated',
            confirmed: 'Cost confirmed',
            waiting_price_confirmation: 'Waiting for confirmation of preliminary cost',
            price_confirmed: 'Cost confirmed',
            master_on_the_way: 'Technician on the way',
            master_arrived: 'Technician has arrived',
            job_started: 'Work started',
            job_finished: 'Work completed',
            closed: 'Close order',
            canceled: 'Order cancelled',
        },
        notifications: {
            newClient: 'New clients',
            clientDescription: 'just registered in the application',
            newRequest: 'New orders',
            requestTitle: 'Unprocessed orders',
            requestDescription: 'in your calendar',
            newCall: 'New calls',
            callDescription: 'called you',
            newMessage: 'New message',
            messageDescription: 'sent you a new message',
            cancelRequest: 'The request is canceled',
            cancelRequestDescription: 'cancelled the request',
            partners: 'Partners',
            newLandingRequest: 'New landing request',
            newLandingRequestDesc: 'New landing request description ',
            viewNewRequest: 'View a new request',
            masterWasLate: 'A master was late',
            masterWasLateDescription: 'A master was late, call him',

            missedCall: 'You\'ve missed call from',
            callBack: 'call back',

            requestCanceled: 'Request canceled',

            clientCreated: 'Client created',
            clientCreatedDesc: 'You\'ve successfully created a new client',

            messageSent: 'Message sent',
            messageSentDesc: 'You\'ve already sent a message',

            deleteMaster: 'You can\'t remove this master.',
            deleteMasterText: 'You can\'t remove this master. The Master has opened request.',

            client_unremovable: 'Client has open requests',
            client_unremovable_text: 'Client has open requests and can\'t be removed',

            badgeCreated: 'Badge created',
            badgeCreatedText: 'You\'ve successfully created the badge',
            badgeUpdated: 'Badge updated',
            badgeUpdatedText: 'You\'ve successfully updated the badge',
            badgeDeleted: 'Badge deleted',
            badgeDeletedText: 'You\'ve successfully deleted the badge',
            badgesHandyman: 'Handyman badges updated',
            badgesHandymanText: 'You\'ve successfully updated handyman badges',
        },
        errors: {
            required: 'Mandatory field.',
            name: 'Mandatory field. Should be 1 to 16 characters in length',
            email: 'Mandatory field. Example: example@mail.com',
            phone: 'Mandatory field.',
            password: 'Passwords do not match',
            passwordLength: 'Minimum length is 8 characters',
            description: '',
        },
        serverError: {
            phone: 'This phone number is already being used',
            email: 'This email address is already being used',
            password: 'Password is too short, minimum 8 characters',
            service: 'It is impossible to delete the service you have chosen',
            serviceId: 'No service chosen',
            error: 'Error',
        },
        login: {
            enter: 'Log in',
            continue: 'Continue',
            forgotPass: 'Forgot your password?',
            errorAuth: 'Invalid email or password',
            passwordRecovery: 'Recovery',
            password: 'Password',
            emailHolder: 'Enter your email address',
            sendNewPass: 'Please send new password',
            back: 'Back',
            errorForgot: 'Invalid email',
            forgotMess: 'Password successfully sent to your email!',
            ok: 'OK',
        },
        navigation: {
            calendar: 'Calendar',
            engineers: 'Engineers',
            masters: 'Technicians',
            clients: 'Clients',
            company: 'Company',
            chat: 'Chat',
            services: 'Services',
            requests: 'Requests',
            orders: 'Orders',
            partners: 'Partners',
            administrators: 'Administrators',
            main: 'Homepage',
        },
        calendar: {
            newRequest: 'New order',
            street: 'Street',
            apartment: 'Apt',
            entrance: 'Entrance',
            deleteTitle: 'Are you sure you want to cancel this order?',
            addresses: 'Addresses',
            time: 'hours | hour | hours',
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September:',
            october: 'October',
            november: 'November',
            december: 'December',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday ',
        },
        controls: {
            searchHolder: 'Search',
            list: 'List',
            map: 'Map',
            month: 'Month',
            fourDays: 'Four days',
            day: 'Day',
            engineers: 'Engineers',
            masters: 'Technicians',
            callSign: 'Call sign',
            badges: 'badges',
        },
        lists: {
            hide: 'Hide',
            addAddress: 'Add address',
            showAddresses: 'Show address list',
            street: 'St.',
            office: 'Office.',
            listEmpty: 'List is empty.',
            deleteMessage: 'Are you sure you want to delete this client and block them from accessing the application?',
            addNewCompanyEmployee: 'Add a new company member',
            deleteCompanyMess: 'Are you sure you want to delete this company?',
            deleteCompanyEmployeeMess: 'Are you sure you want to delete this employee?',
        },
        listsHeader: {
            image: 'Image',
            full_name: 'Full name',
            phone: 'Phone',
            rate: 'Rating',
            orders: 'Orders',
            busy: 'Busy',
            actions: 'Actions',
            contacts: 'Contacts',
            description: 'Description',
            estimate: 'Estimate',
            time: 'Time',
            email: 'Email',
            price: 'Price',
            status: 'Status',
            address: 'Address',
            date: 'Date',
            service: 'Service',
            title: 'Title',
            shortTitle: 'Short title',
            masterCount: 'Master\'s count',
            orderCount: 'Order\'s count',
            paid: 'Paid',
            notPaid: 'Not paid',
            should_start: 'Should start',
            role: 'Role',
            all: 'All',
            spent: 'Spent',
            numberOfOrdersFrom: 'Number of orders from',
            numberOfOrdersTo: 'Number of orders to',
            createNewClient: 'Add a new client',
            createdAt: 'Created at',
        },
        request: {
            newHeader: 'Create order',
            street: 'St.',
            office: 'Office',
            entrance: 'Entrance',
            continue: 'Continue',
            exit: 'Exit',
            dateHolder: 'Choose date',
            problem: 'Describe your problem',
            mediaButton: 'Add photo / video',
            requestTime: 'Time required (hours):',
            timeTitle: 'Clients will be informed about preliminary prices based on the cost of work per hour for this service and the amount of time required.',
            responsible: 'Person in charge',
            addRequest: 'Place order',
            errorMedia: 'File size should not exceed 50 MB',
            responsibleTitle: 'Choose person in charge',
            servicesHold: 'Choose service ',
            newRequestTitle: 'New order',
            masterComing: 'Technician arrival time',
            otherTime: 'Other time options',
            confirmTitle: 'Accept order',
            deleteRequest: 'Reject order',
            comment: 'Comment',
        },
        forms: {
            noOrders: 'No orders',
            name: 'First name',
            surname: 'Last name',
            phone: 'Phone number',
            password: 'Enter new password',
            companyLogo: 'Company logo',
            ownerLogo: 'Photo of the person in charge',
            companyName: 'Company name',
            ownerName: 'First name of the person in charge',
            ownerSurname: 'Last name of the person in charge',
            post: 'Position',
            country: 'Country',
            city: 'City',
            street: 'Street',
            house: 'House',
            entrance: 'Entrance',
            office: 'Office',
            description: 'Additional information',
            passEnter: 'Enter password',
            comeUpPass: 'Create password',
            comeUpPassAgain: 'Confirm password',
            errorPass: 'Passwords do not match',
            create: 'Create',
            status: 'Status',
            price: 'Price',
            price15: 'Price for 15 minutes',
            downloadReceipt: 'Download receipt',
            materials: 'Materials',
            paidStatus: 'An application\'s paid status',
            timeRequired: 'Time required',
            flexibleTime: 'Time is flexible',
            unflexibleTime: 'Time is not flexible',
            predictedFor: 'Predicted from',
            predictedTill: 'Predicted till',
            active: 'active',
            master: 'Master',
            company: 'Company',

            doesKnow: 'does know',
            doesntKnow: 'doesn\'t know',
            recommendPrice: 'Recommend Price',
            spentFrom: 'Spent from',
            spentTo: 'Spent to',

            noImages: 'No images',
            noDescription: 'No description',
            orderAndImages: 'Order images and description',
            addressComment: 'Address comment',
            client: 'Client',
            contactInfo: 'Contact info',
            chooseDate: 'Choose date and estimate',

            sendBill: 'Send the bill',
            agree: 'Agree',

            orderInvoice: 'Order invoice',
            openOrderInvoice: 'Open a pdf file',

            orderAct: 'Act of executed work',
            openOrderAct: 'Open a pdf file',

            snackbarMessage: 'You\'ve closed order modal window.',
            snackbarReopen: 'Reopen',

            addBadge: 'Add a new badge',
            updateBadge: 'Update the badge',
            selectCategory: 'Select category',

            isMultipleOrder: 'Is multiple days order?',
            orderUniqueId: 'Order unique ID',
            allHandyman: 'All handyman',

            moreImages: 'More images',
            source: 'Source',
            undefined: 'Undefined',
        },
        admin: {
            title: 'Personal information',
            exit: 'Exit',
            changePass: 'Change Password',
            passEnter: 'Enter new password',
            passEnterAgain: 'Re-enter new password',
            notification: 'Notification settings',
            notificationDescription: 'Which types of notices you would like to receive ?',
            notificationMessages: 'Notices about new messages.',
            notificationCalls: 'Notices about new calls.',
            notificationRequests: 'Notices about new orders.',
            notificationClients: 'Notices about the registration of new clients.',
        },
        pages: {
            newCompany: 'New company',
            newCompanyUserTitle: 'New company member',
            addEmployeeTitle: 'Add new company',
            newEngineerTitle: 'New engineer',
            addEngineerTitle: 'Add new engineer',
            newMasterTitle: 'New technician',
            addMasterTitle: 'Add new technician',
        },
        services: {
            title: 'New service',
            services: 'Services',
            serviceName: 'Service name',
            serviceCost: 'Cost per hour',
            description: 'Description',
            downIcon: 'Download service icon',
            downIconTitle: 'This image will be displayed in the calendar both in the administrator\'s account and client account',
            serviceColor: 'Choose service color',
            serviceColorTitle: 'All activities in the calendar for this service will be displayed in selected color',
            deleteTitle: 'Are you sure you want to delete this service?',
            editService: 'edit service',
            deleteTooltip: 'delete service',
            addNewService: 'Add a new service',
            serviceAnimation: 'Animation',
            serviceAnimationText: 'Animation which will be showed in the mobile app',
            electrician: 'Electrician',
            plumber: 'Plumber',
            gardener: 'Gardener',
            handyman: 'Handyman',
        },
        materials: {
            add: 'Add a new material',
            shortAdd: 'Add material',
            newMaterial: 'New material',
            updateMaterial: 'Update material',
            title: 'Name ( max 32 symbols )',
            headTitle: 'Name',
            shortTitle: 'Enter a short name ( highly recommended 12 symbols )',
            headShortTitle: 'Short name',
            enterTitle: 'Enter name',
            enterShortTitle: 'Enter a short name',
            price: 'Price',
            enterPrice: 'Enter price',
            image: 'Image',
            actions: 'Actions',
            icon: 'Icons',
            deleteTooltip: 'delete material',
            editTooltip: 'edit material',
            updateBtn: 'Update material',
            viewMaterials: 'view materials',
            areUsure: 'Are you sure?',
            deleteMaterial: 'Delete?',
            cancelDeleteMaterial: 'Cancel',
            titleMaxSize: 'Max characters length is 32',
        },
        ordersStatus: {
            new: 'Order is pending',
            confirmed: 'Order confirmed',
            master_on_the_way: 'Master on the way',
            master_arrived: 'Master arrived',
            job_started: 'Master is working',
            job_finished: 'Master finished work',
            payment: 'Payment',
            rating_review: 'Rating',
            finished: 'Finished',
            canceled: 'Canceled',
            closed: 'Closed',
            free: 'Free',
            stand_by: 'Stand by',
            not_selected: 'not selected',
            cash: 'cash',
            card: 'card',
            bill: 'bill',
            attachmentsGenerating: 'Attachments generating',
        },
        partners: {
            add: 'Add a new partner',
            update: 'Update a partner',
        },
        administrators: {
            create: 'Create',
            add: 'Add a new administrator',
            update: 'Update an administrator',
            name: 'Name',
            enterName: 'Enter name',
            surname: 'Surname',
            email: 'Email',
            phone: 'Phone',
            password: 'Password',
            enterPassword: 'Enter password',
            deleteTitle: 'Are you sure you want delete this administrator?',
        },
        metrics: {
            booked: 'booked',
            workload: 'workload',
            discipline: 'discipline',
            factual_workload: 'factual workload',
        },
        roles: {
            superadmin: 'Super admin',
            advancedadmin: 'Advanced admin',
            partneradmin: 'Partner admin',
            normaladmin: 'Normal admin',
            technicaladmin: 'Technician admin',
        },
    },
    de: {
        lang: {
            en: 'Englisch',
            de: 'Deutsch',
        },
        global: {
            serviceHolder: 'Service',
            cancel: 'Abbrechen',
            close: 'Schließen',
            add: 'Hinzufügen',
            delete: 'Löschen',
            edit: 'Ändern',
            ok: 'ОК',
            save: 'Speichern',
            toDay: 'Heute',
            messageEmpty: 'Keine Nachrichten',
            image: 'Bild',
            show: 'Anzeigen',
            hide: 'Ausblenden',
            areUsure: 'Bist du sicher?',
        },
        call: {
            screenShot: 'Screenshot erstellen',
            connect: 'Verbindung herstellen mit',
        },
        status: {
            new: 'In der Bearbeitung',
            approved: 'Installateure sind zugewiesen, der Kostenvoranschlag wird erstellt',
            confirmed: 'Preis bestätigt',
            waiting_price_confirmation: 'Erwartet die Bestätigung',
            price_confirmed: 'Preis bestätigt',
            master_on_the_way: 'Der Installateur ist unterwegs',
            master_arrived: 'Der Installateur ist angekommen',
            job_started: 'Die Arbeit ist begonnen',
            job_finished: 'Die Arbeit ist fertig',
            closed: 'Auftrag abschlißen',
            canceled: 'Der Auftrag ist abgebrochen',
        },
        notifications: {
            newClient: 'Neue Kunden',
            clientDescription: 'gerade in der Anwendung registriert',
            newRequest: 'Neue Aufträge',
            requestTitle: 'Unbearbeitete Aufträge',
            requestDescription: 'in Ihrem Kalender',
            newCall: 'Neue Anrufe',
            callDescription: 'hat angerufen',
            newMessage: 'Neue Nachricht',
            messageDescription: 'hat Ihnen eine Nachricht geschickt',
            cancelRequest: 'stornierte die Bestellung',
            cancelRequestDescription: 'hat die Anfrage abgelehnt',
            newLandingRequest: 'Neue Landeanfrage',
            newLandingRequestDesc: 'Neue Landeanfrage',
            viewNewRequest: 'Neue Anfrage anzeigen',
            masterWasLate: 'Ein Meister war zu spät',
            masterWasLateDescription: 'Ein Meister war zu spät, ruf ihn an',

            mailSent: 'Mail gesendet',
            mailSentText: 'Sie haben erfolgreich eine E-Mail gesendet',
            clientUpdated: 'Client aktualisiert',
            clientUpdatedText: 'Sie haben das Profil eines Kunden erfolgreich aktualisiert',
            scheduleAdd: 'Zeitplan hinzugefügt',
            scheduleAddText: 'Sie haben erfolgreich einen Master-Zeitplan hinzugefügt',
            orderUpdated: 'Bestellung wurde aktualisiert',
            orderUpdatedText: 'Sie haben eine Bestellung erfolgreich aktualisiert',
            orderCreated: 'Auftrag erstellt',
            orderCreatedText: 'Bestellung erfolgreich erstellt wurde',
            masterAdded: 'Meister hinzugefügt',
            masterAddedText: 'Sie haben erfolgreich einen neuen Master hinzugefügt',
            masterUpdated: 'Master aktualisiert',
            masterUpdatedText: 'Sie haben einen Master erfolgreich aktualisiert',
            animationUploaded: 'Animation hochgeladen',
            animationUploadedText: 'Sie haben erfolgreich eine Animation hochgeladen',
            passwordChanged: 'Passwort geändert',
            passwordChangedText: 'Sie haben ein Passwort erfolgreich aktualisiert',

            missedCall: 'Verpasster Anruf',
            missedCallText: 'Sie haben den Anruf von verpasst',
            callBack: 'Ruf zurück',
            clientCreated: 'Client erstellt',
            clientCreatedDesc: 'Sie haben erfolgreich einen neuen Client erstellt',

            messageSent: 'Nachricht gesendet',
            messageSentDesc: 'Sie haben bereits eine Nachricht gesendet',

            deleteMaster: 'Sie können den Master nicht entfernen.',
            deleteMasterText: 'Sie können den Master nicht entfernen. Der Master hat die Anfrage geöffnet.',

            client_unremovable: 'Client hat offene Anfragen',
            client_unremovable_text: 'Der Client hat offene Anforderungen und kann nicht entfernt werden',

            badgeCreated: 'Abzeichen erstellt',
            badgeCreatedText: 'Sie haben das Abzeichen erfolgreich erstellt',
            badgeUpdated: 'Abzeichen aktualisiert',
            badgeUpdatedText: 'Sie haben das Abzeichen erfolgreich aktualisiert',
            badgeDeleted: 'Abzeichen gelöscht',
            badgeDeletedText: 'Sie haben das Abzeichen erfolgreich gelöscht',
            badgesHandyman: 'Handwerkerabzeichen aktualisiert',
            badgesHandymanText: 'Sie haben die Handwerkerabzeichen erfolgreich aktualisiert',

            tagAdded: 'Tags aktualisiert',
            tagAddedText: 'Sie haben die Tags des Masters erfolgreich aktualisiert',
        },
        errors: {
            required: 'Pflichtfeld.',
            name: 'Pflichtfeld. Die Länge sollte von 1 bis 16 Zeichen betragen',
            email: 'Pflichtfeld. Beispiel: example@mail.com',
            phone: 'Pflichtfeld. ',
            password: 'Passwörter stimmen nicht überein',
            passwordLength: 'Die Länge sollte mindestens 8 Zeichen betragen',
            description: '',
        },
        serverError: {
            phone: 'Diese Telefonnummer ist bereits verwendet',
            email: 'Diese E-Mail-Adresse wird bereits verwendet',
            password: 'Das Passwort ist zu kurz, es sollte mindestens 8 Zeichen betragen',
            service: 'Die Leistung kann nicht gelöscht werden, wenn sie an Aufträgen gebunden ist',
            serviceId: 'Es wurde keine Leistung ausgewählt',
            error: 'Fehler',
        },
        login: {
            enter: 'Anmelden',
            continue: 'Weiter',
            forgotPass: 'Passwort vergessen?',
            errorAuth: 'Falsche E-Mail oder Passwort',
            passwordRecovery: 'Passwort zurücksetzen',
            password: 'Passwort',
            emailHolder: 'Geben Sie Ihre E-Mail an',
            sendNewPass: 'Neues Passwort schicken',
            back: 'Zurück',
            errorForgot: 'Falsche E-Mail',
            forgotMess: 'Das Passwort wurde auf Ihre E-Mail geschickt!',
            ok: 'OK',
        },
        navigation: {
            calendar: 'Kalender',
            engineers: 'Ingenieure',
            masters: 'Fachleute',
            clients: 'Kunden',
            company: 'Firma',
            chat: 'Chat',
            services: 'Leistungen',
            requests: 'Anfragen',
            orders: 'Aufträge',
            partners: 'Gesellschafter',
            administrators: 'Administratoren',
            main: 'Homepage',
        },
        masters: {
            addTech: 'Neuer Techniker',
            addEng: 'Neuer Ingenieur',
            add: 'Füge einen neuen Meister hinzu',
            update: 'Meister aktualisiert',
            reviews: 'Meister-Rezensionen',
            data: 'Stammdaten des Meisters',
            cReviews: 'Rezensionen',
        },
        schedule: {
            workingTime: 'Arbeitszeit von',
            weekDays: 'Wochentage',
            period: 'Periode des Arbeitsplanes',
            from: 'Von',
            to: 'bis',
        },
        calendar: {
            newRequest: 'Neuer Auftrag',
            street: 'Straße',
            apartment: 'Türnummer',
            entrance: ' Eingang',
            deleteTitle: 'Möchten Sie den Auftrag löschen?',
            addresses: 'Adressen',
            time: 'Stunden | Stunde | Stunden',
            january: 'Januar',
            february: 'Februar',
            march: 'März',
            april: 'April',
            may: 'Mai',
            june: 'Juni',
            july: 'Juli',
            august: 'August',
            september: 'September',
            october: 'Oktober',
            november: 'November',
            december: 'Dezember',
            monday: 'Montag',
            tuesday: 'Dienstag',
            wednesday: 'Mittwoch',
            thursday: 'Donnerstag',
            friday: 'Freitag',
            saturday: 'Samstag',
            sunday: 'Sonntag',
        },
        controls: {
            searchHolder: 'Suchen',
            list: 'Liste',
            map: 'Karte',
            month: 'Monat',
            fourDays: '4 Tage',
            day: 'Tag',
            engineers: 'Ingenieure',
            masters: 'Fachleute',
            callSign: 'Rufzeichen',
            badges: 'Abzeichen',

            work: 'Arbeit',
            works: 'Arbeiten',
            skills: 'Fertigkeiten',
            tools: 'Werkzeuge',
        },
        lists: {
            hide: 'Ausblenden',
            addAddress: 'Adresse hinzufügen',
            showAddresses: 'Liste der Adressen anzeigen',
            street: 'Straße.',
            office: 'Büro.',
            listEmpty: 'Liste ist leer.',
            deleteMessage: 'Möchten Sie den Account des Benutzers löschen/blockieren?',
            addNewCompanyEmployee: 'Einen neuen Teilnehmer hinzufügen',
            deleteCompanyMess: 'Möchten Sie die Firma löschen?',
            deleteCompanyEmployeeMess: 'Möchten Sie den Mitarbeiter löschen?',
        },
        listsHeader: {
            image: 'Bild',
            full_name: 'Vollständiger Name',
            phone: 'Telefon',
            rate: 'Bewerten',
            orders: 'Aufträge',
            busy: 'Beschäftigt',
            actions: 'Aktionen',
            contacts: 'Kontakte',
            description: 'Beschreibung',
            estimate: 'Schätzung',
            time: 'Zeit',
            email: 'Email',
            price: 'Preis',
            status: 'Bezahlung',
            address: 'Adresse',
            date: 'Datum',
            service: 'Dienstname',
            title: 'Titel',
            shortTitle: 'Kurzer Titel',
            masterCount: 'Anzahl der Meister',
            orderCount: 'Anzahl der Bestellungen',
            paid: 'Bezahlt',
            notPaid: 'Nicht bezahlt',
            should_start: 'Sollte beginnen',
            role: 'Rolle',
            all: 'Alle',
            spent: 'Verbraucht',
            numberOfOrdersFrom: 'Anzahl an Bestellungen ab',
            numberOfOrdersTo: 'Anzahl an Bestellungen bis',
            createNewClient: 'Erstellen Sie einen neuen Kunden',
            createdAt: 'Hergestellt in',

            canUseScooter: 'Scooter benutzen',
            toolName: 'Werkzeugname',
            skillName: 'Name der Fertigkeit',
            author: 'Autor',
        },
        request: {
            newHeader: 'Auftrag hinzufügen',
            street: 'Straße',
            office: 'Office',
            entrance: ' Eingang',
            continue: 'Weiter',
            exit: 'Abmelden',
            dateHolder: 'Datum wählen',
            problem: 'Problem',
            mediaButton: 'Foto/Video hinzufügen ',
            requestTime: 'Durchführungszeit (Stunden):',
            timeTitle: 'Der Kunde wird einen Kostenvoranschlag auf der Grundlage der Arbeitsstunden für diese Leistung und die Menge der Zeit erhalten.',
            responsible: 'Verantwortlichen',
            addRequest: 'Den Antrag hinzufügen',
            errorMedia: 'Die Datei darf nicht 50 Mb überschritten.',
            responsibleTitle: 'Verantwortlichen auswählen',
            servicesHold: 'Service auswählen',
            newRequestTitle: 'Neuer Auftrag',
            masterComing: 'Ankunftszeit des Installateurs',
            otherTime: 'Anderen Zeitpunkt vorschlagen',
            confirmTitle: 'Den Auftrag annehmen',
            deleteRequest: 'Den Auftrag ablehnen',
            comment: 'Comment',
        },
        forms: {
            noOrders: 'keine Bestellungen',
            name: 'Vorname',
            surname: 'Nachname',
            phone: 'Telefonnummer',
            password: ' Passwort ',
            companyLogo: 'Firmenlogo',
            ownerLogo: 'Foto des Verantwortlichen',
            companyName: 'Firmenname',
            ownerName: 'Name des Verantwortlichen',
            ownerSurname: 'Nachname des Verantwortlichen',
            post: 'Stelle',
            country: 'Land',
            city: 'Stadt',
            street: 'Straße',
            house: 'Hausnummer',
            entrance: 'Eingang',
            office: 'Büro',
            description: 'Kommentare',
            passEnter: 'Passwort eingeben',
            comeUpPass: 'Passwort erstellen',
            comeUpPassAgain: 'Passwort wiederholen',
            errorPass: 'Passwörter stimmen nicht überein',
            create: 'Erstellen',

            status: 'Status',
            price: 'Preis',
            price15: 'Preis für 15 Minuten',
            downloadReceipt: 'Rechnung herunterladen',
            materials: 'Materialien',
            paidStatus: 'Antrag bezahlt Status',
            timeRequired: 'Benötigte Zeit',
            flexibleTime: 'Die Zeit ist flexibel',
            unflexibleTime: 'Die Zeit ist nicht flexibel',
            predictedFor: 'Vorhergesagt von',
            predictedTill: 'Vorhergesagt bis',
            active: 'aktiv',
            master: 'Meister',
            company: 'Firma',
            comment: 'Kommentar',
            noRewiews: 'Keine Bewertungen',
            enterAddress: 'Adresse eingeben',
            enterUrAddress: 'Geben Sie Ihre Adresse ein',

            doesKnow: 'kann',
            doesntKnow: 'kann nicht',
            recommendPrice: 'Preis empfehlen',
            apartment: 'Türnummer',
            spentFrom: 'Ausgeben ab',
            spentTo: 'Ausgeben bis',

            noImages: 'Keine Bilder',
            noDescription: 'Keine Beschreibung',
            orderAndImages: 'Bilder und Beschreibung des Auftrages',
            addressComment: 'Adresskommentar',
            client: 'Kunde',
            contactInfo: 'Kontaktinformation',
            chooseDate: 'Wählen Sie Datum und Schätzung',
            sendBill: 'Senden Sie die Rechnung',
            agree: 'Zustimmen',

            orderAct: 'Arbeitsschein',
            openOrderAct: 'Öffnen Sie eine PDF-Datei',

            orderInvoice: 'Rechnung bestellen',
            openOrderInvoice: 'Öffnen Sie eine PDF-Datei',

            snackbarMessage: 'Sie haben das modale Bestellfenster geschlossen.',
            snackbarReopen: 'Wieder öffnen',

            addBadge: 'Füge ein neues Abzeichen hinzu',
            updateBadge: 'Aktualisieren Sie das Abzeichen',
            selectCategory: 'Kategorie wählen',

            isMultipleOrder: 'Für mehrere Tage bestellt?',
            orderUniqueId: 'Bestellen Sie eine eindeutige ID',
            allHandyman: 'Alle Handwerker',

            moreImages: 'mehr Bilder',
            source: 'Quelle',
            undefined: 'Nicht definiert',
            select: 'Wählen',

            createTag: 'Tag erstellen',
            updateTag: 'Tag aktualisieren',
            default: 'Standardeinstellung',
            createSkill: 'Fertigkeit erstellen',
            updateSkill: 'Fertigkeit aktualisieren',
            createTool: 'Werkzeug erstellen',
            updateTool: 'Werkzeug aktualisieren',
        },
        admin: {
            title: 'Persönliche Informationen',
            exit: 'Abmelden',
            changePass: 'Passwort ändern',
            passEnter: 'Neues Passwort eingeben',
            passEnterAgain: 'Passwort wiederholen',
            notification: 'Benachrichtigungen',
            notificationDescription: 'Welche Arten von Benachrichtigungen möchten Sie erhalten?',
            notificationMessages: 'Benachrichtigungen über neue Nachrichten.',
            notificationCalls: 'Benachrichtigungen über neue Anrufe.',
            notificationRequests: 'Benachrichtigungen über neue Anfragen.',
            notificationClients: 'Benachrichtigungen über die Registrierung neuer Kunden.',
        },
        pages: {
            newCompany: 'Neue Firma',
            newCompanyUserTitle: 'Neuer Teilnehmer der Firma',
            addEmployeeTitle: 'Neue Firma hinzufügen',
            newEngineerTitle: 'Neuer Ingenieur',
            addEngineerTitle: 'Neuen Ingenieur hinzufügen',
            newMasterTitle: 'Neuer Installateur',
            addMasterTitle: 'Neuen Installateur hinzufügen',
        },
        services: {
            title: 'Neue Leistung',
            services: 'Dienstleistungen',
            serviceName: 'Name der Leistung',
            serviceCost: 'Preis pro Stunde',
            description: 'Beschreibung',
            downIcon: 'Bild herunterladen',
            downIconTitle: 'Das Bild wird im Kalender in der CMS als auch beim Kunden in der App angezeigt.',
            serviceColor: 'Farbe der Leistung auswählen',
            serviceColorTitle: 'Alle Aktivitäten im Kalender nach der Leistung werden in der ausgewählten Farben angezeigt.',
            deleteTitle: 'Möchten Sie den Service löschen?',
            addNewService: 'Einen neuen Dienst hinzufügen ',
            serviceAnimation: 'Animation',
            serviceAnimationText: 'Animation, die in der mobilen Anwendung gezeigt wird ',

            electrician: 'Elektriker',
            plumber: 'Installateur',
            gardener: 'Gärtner',
            handyman: 'Handwerker',
        },
        materials: {
            add: 'ein neues Material hinzufügen ',
            shortAdd: 'in neues Material',
            newMaterial: 'Ein neues Material',
            title: 'Titel',
            shortTitle: 'kurzer Titel',
            enterTitle: 'einen Titel eingeben',
            enterShortTitle: 'Einen kurzen Titel eingeben ',
            price: 'Preis',
            enterPrice: 'einen Preis eingeben',
            image: 'Bild',
            actions: 'Aktionen',
            icon: 'Symbol',
            updateMaterial: 'ein Material ändern',
        },
        ordersStatus: {
            new: 'Bestellung ausstehend',
            confirmed: 'Bestellung bestätigt',
            master_on_the_way: 'Meister unterwegs',
            master_arrived: 'Meister eingetroffen',
            job_started: 'Meister arbeitet',
            job_finished: 'Meister hat die Arbeit beendet',
            payment: 'Bezahlung',
            rating_review: 'Bewertung',
            finished: 'Finished',
            canceled: 'Stornieren',
            closed: 'Geschlossen',
            free: 'Frei',
            not_selected: 'nicht ausgewählt',
            cash: 'kasse',
            card: 'karte',
            bill: 'gesetzentwurf',
            stand_by: 'Stand by',
            attachmentsGenerating: 'Anhänge erzeugen',
        },
        partners: {
            add: 'Fügen Sie einen neuen Partner hinzu',
            update: 'Einen Partner aktualisieren',
        },
        administrators: {
            create: 'Create',
            add: 'Fügen Sie einen neuen Administrator hinzu',
            update: 'Aktualisieren Sie einen Administrator',
            name: 'Name',
            enterName: 'Enter name',
            surname: 'Surname',
            email: 'Email',
            phone: 'Phone',
            password: 'Password',
            enterPassword: 'Enter password',
            deleteTitle: 'Möchten Sie diesen Administrator wirklich löschen?',
        },
        metrics: {
            booked: 'gebucht',
            workload: 'Arbeitsbelastung',
            discipline: 'Disziplin',
            factual_workload: 'faktische Arbeitsbelastung',
        },
        mails: {
            subject: 'Betreff',
            message: 'Text',
            chooseFile: 'Datei wählen',
            send: 'Senden',
            createTitle: 'Senden Sie eine neue E-Mail',
        },
        public: {
            passwordRecoveryTitle: 'Passwort-Wiederherstellung',
            passwordChanged: 'Passwort erfolgreich geändert',
            enterPassword: 'Passwort eingeben',
            confirmPassword: 'Passwort bestätigen',
            emailConfirmed: 'Ihre E-Mail wurde erfolgreich bestätigt',
            somethingWentWrong: 'Ups, etwas ist schief gelaufen',
        },
        roles: {
            superadmin: 'Super administrator',
            advancedadmin: 'Fortgeschrittener administrator',
            partneradmin: 'Partner administrator',
            normaladmin: 'Normaler administrator',
            technicaladmin: 'Technischer administrator',
        },
        smsMessages: {
            confirmed: 'Wir werden eine Nachricht wie diese senden:  Ihr Auftrag ist bestätigt. Ein Handwerker wird Ihr Problem am {date} um {time} Uhr lösen.',
        },
    },
}
